import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';
import ModalBoxBadge from './ModalBoxBadge';

function ModalBoxPagination(props) {
	const { page, setPage, pagesCount, badge } = props;
	if (pagesCount <= 1) {
		return null;
	}

	const pages = Array.from(Array(pagesCount).keys());

	const setPrevPage = () => {
		setPage(page - 1);
	};

	const setNextPage = () => {
		setPage(page + 1);
	};

	return (
		<div className={style.modalPaginationWrapper}>
			<ModalBoxBadge text={badge} />
			<div className={style.modalPagination}>
				{page > 0 ? (
					<div onClick={setPrevPage} className={style.modalPaginationArrow}>
						<i className="icon -icon-single-arrow-left-line" />
					</div>
				) : (
					<div></div>
				)}
				<div className={style.modalPaginationItems}>
					{pages.map((i) => (
						<div
							onClick={() => setPage(i)}
							className={style.modalPaginationItem + (i === page ? ' ' + style.modalPaginationItemActive : '')}
						></div>
					))}
				</div>
				{page < pagesCount - 1 ? (
					<div onClick={setNextPage} className={style.modalPaginationArrow}>
						<i className="icon -icon-single-arrow-right-line" />
					</div>
				) : (
					<div></div>
				)}
			</div>
		</div>
	);
}

ModalBoxPagination.propTypes = {
	pagesCount: PropTypes.number.isRequired,
	setPage: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	badge: PropTypes.string,
};

export default ModalBoxPagination;
